import WalletIcon from './WalletIcon';
import GameHeaderButton from '../../GameHeaderButton';
import useOpenCloseCashier from '@/client/components/CashierWrap/useCashier/useOpenCloseCashier';
import { CashierCurrencyType } from '@/graphql/schema';

type Props = {
  type?: CashierCurrencyType;
  name?: CashierCurrency;
};

const WalletButton: FC<Props> = ({ type = 'crypto', name: icon }) => {
  const { handleOpen } = useOpenCloseCashier({
    type,
    name: icon as CashierCurrency,
    cashierPath: 'deposit',
  });

  return (
    <GameHeaderButton className="text-piccolo" onClick={handleOpen}>
      <WalletIcon />
    </GameHeaderButton>
  );
};

export default WalletButton;
